export type ReducerAction<Type> = { type: Type };
export type ReducerActionWithPayload<Type, Payload> = { type: Type; payload: Payload };

export type ActionHandlers<State, Actions extends ReducerAction<any> | ReducerActionWithPayload<any, any>> = {
    [k in Actions['type']]: (state: State, action: Extract<Actions, { type: k }>) => State;
};
/**
 * Creates a reducer function that accepts action handlers object
 * where key is action type and value is a reducer function.
 * @param handlers
 */
export function createReducer<State, Actions extends ReducerAction<any> | ReducerActionWithPayload<any, any>>(
    handlers: ActionHandlers<State, Actions>
): (s: State, action: Actions) => State {
    return (state, action) => {
        if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
            return handlers[action.type as keyof ActionHandlers<State, Actions>](state, action as any);
        }

        return state;
    };
}
